__turbopack_context__.v({
  "hideDesktop": "SrL0Sq_hideDesktop",
  "hideLarge": "SrL0Sq_hideLarge",
  "hideMobile": "SrL0Sq_hideMobile",
  "hideTablet": "SrL0Sq_hideTablet",
});
